import React from "react";
import "./Template_3.css";

const Template_3_Header = () => {
  return (
    <header className="Template_3 header">
      <div className="Template_3 container">
        <div className="Template_3 header-content">
          <div className="Template_3 logo">
            <i className="fas fa-compass"></i>
            WanderLux
          </div>
          <nav>
            <ul>
              <li>
                <a href="/template_3_homepage">Home</a>
              </li>
              <li>
                <a href="#">Experiences</a>
              </li>
              <li>
                <a href="#">Locales</a>
              </li>
              <li>
                <a href="#about">About</a>
              </li>
              <li>
                <a href="#reviews">Testimonials</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Template_3_Header;
